export default () => ({
  showModalState: false,
  email: null,
  logo: null,
  isAdmin: false,
  accountId: null,
  userId: null
})
